export function utc_timestamp_to_local_datetime_string(ts){
  let date_string = new Date(ts).toLocaleDateString("en-US");
  let time_string = new Date(ts).toLocaleTimeString("en-US", {timeZoneName: "short"})

  return date_string + " " + time_string;
}

export function utc_timestamp_to_local_date_string(ts){
  let date_string = new Date(ts).toLocaleDateString("en-US");

  return date_string;
}

export function utc_timestamp_to_hours_ago_string(ts){
  if (!ts) return "";

  const diffMs = Date.now() - Number(ts);
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));

  if (diffHours < 1) {
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    if (diffMinutes < 1) return "just now";
    return `${diffMinutes} min ago`;
  }

  return `${diffHours} hrs ago`;
};